import script from "./NoticeBoardBase.vue?vue&type=script&setup=true&lang=js"
export * from "./NoticeBoardBase.vue?vue&type=script&setup=true&lang=js"

import "./NoticeBoardBase.vue?vue&type=style&index=0&id=05160030&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05160030"]])

export default __exports__